import { s as i } from "./chart-base-DQP-2wFc.js";
function e(r, o = " ") {
  if (r)
    return i(r, o);
}
export {
  e as c
};
